import request from 'api/requestUtils'
import qs from 'qs'
import { isAgentHubTravellerOrder } from 'lib/order/agentHubTravellerOrder'
import { mapOrderResponse } from './mappers/orderMap'

function orderByIdRequest(id: string) {
  const query = qs.stringify({
    include_cancellation_config: true,
  })
  return request.get<App.ApiResponse<unknown>>(`/api/orders/${id}?${query}`, { credentials: 'include' })
    .then(response => mapOrderResponse(response.result, 'full'))
}

export function getStoredOrderById(id: string) {
  return orderByIdRequest(id)
}

export function getOrderById(id: string): Promise<App.Order> {
  return getStoredOrderById(id).then((order) => {
    if (isAgentHubTravellerOrder(order)) {
      throw Object.assign(new Error('Forbidden'), { status: 403 })
    }
    return order
  })
}
